import { useTranslation } from "react-i18next";
import {
    ColumnButtons,
    SubnavPanelBody,
    IconNavItem,
    NavCard,
    NavColumn,
} from "~/components/header/full-header/subnavigation/common";
import { RiArrowRightSLine } from "@remixicon/react";
import { Button } from "~/components/ui/button";
import { Link } from "~/components/ui/link";
import { imageUrl } from "~/lib/image-url";

// Plain public/ string path, not a JS import — see the comment on bgImageSet in
// app/components/home/UseCases.tsx for why.
const personalUseCardImg = imageUrl("/images/subnav/personal-use-smart-living.jpg");

export default function PersonalUseNavItem({ onNavigate }: { onNavigate: () => void }) {
    const { t } = useTranslation("common");

    const forYou: IconNavItem[] = [
        { name: t("subnav.personal_use.families.name"),         href: "/personal-use/families" },
        { name: t("subnav.personal_use.teen_drivers.name"),      href: "/personal-use/teen-drivers" },
        { name: t("subnav.personal_use.aging_parents"),          href: "/personal-use/senior-drivers" },
        { name: t("subnav.personal_use.tech_enthusiasts.name"),  href: "/personal-use/tech-enthusiasts" },
    ];

    return (
        <SubnavPanelBody
            // size="lg" + a wider px gives this a bigger hit box than the plain default
            // link size, without changing how it looks (variant="link" has no visible
            // box, so the extra padding/height is invisible).
            footer={
                <Button asChild variant="link" size="lg" className="fleet:text-text-body-tertiary px-8 underline">
                    <Link to="/personal-use" onClick={onNavigate}>
                        {t("subnav.personal_use.all_solutions")}
                        <RiArrowRightSLine className="h-5 w-5" />
                    </Link>
                </Button>
            }
        >
            <div className="flex items-start justify-center gap-20">
                <NavColumn header={t("subnav.personal_use.col_solutions")} className="w-[180px]">
                    <ColumnButtons onNavigate={onNavigate} buttonData={forYou}/>
                </NavColumn>
                <NavCard
                    className="w-[338px]"
                    image={personalUseCardImg}
                    title={t("subnav.personal_use.card_title")}
                    description={t("subnav.personal_use.card_description")}
                />
            </div>
        </SubnavPanelBody>
    );
}
